
  <ng-template #content let-modal>
    <div dir="rtl">
      <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
        <h4 class="modal-title" id="modal-basic-title"><img src="../../../../assets/icons/{{obj.status}}.svg"></h4>
      </div>
      <div class="modal-body" >
          <p  [innerHTML]="obj.massege"></p>
      </div>

    </div>
    <div class="modal-footer" *ngIf="obj.buttens">
      <button *ngFor="let bt of obj.buttens" type="button" class="btn btn-outline-dark" (click)="modal.close(bt)">{{bt}}</button>
    </div>
  </ng-template>